/** White-fill mark for dark nav / auth / landing (public Supabase object). */
export const NEOGTM_LOGO_PNG_URL =
  'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68d02d32902df753d69e6b12/c5c487382_neo_gtm_white_fill_smooth_edges_v2.png';

/** Full logo for Analytics PDF footer only (public Supabase object). */
export const NEOGTM_LOGO_PDF_URL =
  'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/56e666b60_neogtm_finallogo.png';
